export function receiveStudioUpload<TFile extends { id: string; status: string }, TPrompt extends { id: string }>(
  current: TPrompt | null,
  file: TFile,
  convert: (file: TFile) => TPrompt,
): TPrompt | null {
  if (file.status === 'uploading') return convert(file);
  if (current?.id !== file.id) return current;
  return file.status === 'error' || file.status === 'removed' ? null : convert(file);
}
